<template>
  <section id="app-table">
    <el-table
      :cell-class-name="adminStyle"
      :data="tableData"
      :default-sort="defaultSort"
      row-class-name="table-row table-row--content"
      header-cell-class-name="table-cell__container"
      header-row-class-name="table-row table-row--header"
      @row-click="(row, column) => $emit('onRowClick', row, column)"
      @selection-change="handleSelectItem"
      @cell-click="editClick"
      @sort-change="handleChangeSort"
    >
      <!-- cehckbox列 -->
      <el-table-column type="selection" width="59" align="center" />

      <el-table-column
        v-for="item in columns"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :sortable="item.sortable || false"
        show-overflow-tooltip
        align="center"
      >
        <!-- 表头插槽 -->
        <template v-slot:header="{ column }">
          <!-- 带有下拉菜单的表头 -->
          <table-controller-vue
            v-if="controllers[item.prop]"
            :columnLabel="item.label"
            :controller="controllers[item.prop]"
            @onControllerChange="handleControllerChange"
          />
          <p v-else class="table-cell table-cell--header font-table__header">
            {{ column.label }}
          </p>
        </template>

        <!-- 列内容插槽 -->
        <template v-slot="{ row, column }">
          <sort v-if="item.sort" :name="item.sort"></sort>
          <p
            v-else
            :class="item.contentCellClass"
            class="table-cell table-cell--content font-table__content"
          >
            {{ row[column.property] }}
          </p>
        </template>
      </el-table-column>
    </el-table>
  </section>
</template>

<script>
import tableControllerVue from './table-controller.vue';
export default {
  name: 'Table',

  components: {
    tableControllerVue
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    tableData: {
      type: Array
    },
    controllers: {
      type: Object,
      default: () => ({})
    },
    defaultSort: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      navItem: ''
    };
  },
  methods: {
    /**
     * * 控制器改变回调
     */
    handleControllerChange(controller) {
      this.$emit('onControllerChange', controller);
    },
    handleChangeNavItem(navItem) {
      this.navItem = navItem;
    },

    /**
     * 选中列表项回调
     */
    handleSelectItem(itemList) {
      this.$emit('onSelectItem', itemList);
    },

    /**
     * 编辑按钮回调
     */
    editClick(row, column, cell, event) {
      //用户界面编辑事件
      if (column.property == 'edit' && row.userUserRoleList[0].roleType != 1) {
        this.$emit('onEditUser', row);
      }
      //建筑点击状态栏跳转至单个建筑巡查报告界面
      else if (column.property == 'inspectStatusEnum') {
        this.$emit('onToReportByRelic', row);
      } else if (column.property == 'chaXunBaoGao') {
        this.$emit('onUploadingGisFromTable', row);
      } else {
        //点击表格其他表格进入详情
        this.$emit('onTableItemToDetail', row);
      }
    },
    /**
     * 改变用户模块的编辑栏
     */
    adminStyle({ row, column, rowIndex, columnIndex }) {
      //
      if (row.roleName) {
        if (
          (row.userUserRoleList[0].roleType == 1 &&
            column.property == 'edit') ||
          (row.userUserRoleList[0].roleType == 1 && !column.property)
        ) {
          return 'table-cell__container hidden-edit';
        }
      } else if (
        row.inspectStatusEnum == '异常' &&
        column.property == 'inspectStatusEnum'
      ) {
        return 'table-cell__container danger-relic';
      } else if (
        row.inspectStatusEnum == '未巡查' &&
        column.property == 'inspectStatusEnum'
      ) {
        return 'table-cell__container weixuncha-relic';
      }
      return 'table-cell__container';
    },
    handleChangeSort(sort) {
      // 升序
      if (sort.order == 'ascending') {
        const sortType = false;
        const sortParam = sort.prop;
        this.$emit('onChangeSort', sortType, sortParam);
      }
      //降序
      else {
        const sortType = true;
        const sortParam = sort.prop;
        this.$emit('onChangeSort', sortType, sortParam);
      }
    }
  }
};
</script>

<style lang="scss">
#app-table {
  .table {
    &-cell {
      color: $color-label;
      line-height: 40px;
      &__container {
        padding: 0;
        .cell {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &.descending .sort-caret.descending {
          border-top-color: $color-primary;
        }
        &.ascending .sort-caret.ascending {
          border-bottom-color: $color-primary;
        }
        .sort-caret {
          border-width: 7px;
          border-radius: 3px;
          &.ascending {
            top: 1.5px;
            border-bottom-color: $color-primary-light2;
          }
          &.descending {
            bottom: 1.5px;
            border-top-color: $color-primary-light2;
          }
        }
      }
    }
    &-row {
      &--header {
        .cell {
          padding: 0;
        }
        .table-cell {
          &__container {
            border-color: $color-border;
          }
        }
      }
      &--content {
        cursor: pointer;
        .table-cell__container {
          border-color: #dddddd;
        }
      }
    }
  }
  .el-table {
    &::before {
      background-color: #ddd;
    }
    .hidden-edit {
      .icon-bianji {
        display: none;
      }
    }
    .danger-relic {
      .font-table__content {
        color: red;
      }
    }
    .weixuncha-relic {
      .font-table__content {
        color: rgb(165, 165, 7);
      }
    }
  }
}
</style>
